import { TableColumnsType, Tag } from "antd";
import TableUi from "../../../../../atoms/Table";
import Filters from "./Components/Filters";
import { useState } from "react";

export default function Materials() {
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [archived, isArchived] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const columns: TableColumnsType = [
    {
      title: "Material name",
      dataIndex: "material_name",
      width: 240,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.material_name?.localeCompare(b?.material_name),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 64,
      sorter: (a, b) => a?.unit?.localeCompare(b?.unit),
    },
    {
      title: "Estimated",
      dataIndex: "estimated",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.estimated?.localeCompare(b?.estimated),
    },
    {
      title: "Allocated",
      dataIndex: "allocated",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.allocated?.localeCompare(b?.allocated),
    },
    {
      title: "On order",
      dataIndex: "on_order",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.on_order?.localeCompare(b?.on_order),
    },
    {
      title: "Used to date",
      dataIndex: "used_to_date",
      width: 140,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.used_to_date?.localeCompare(b?.used_to_date),
    },
    {
      title: "Purchase orders",
      dataIndex: "purchase_orders",
      width: 200,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.purchase_orders?.localeCompare(b?.purchase_orders),
    },
    {
      title: "Subservices",
      dataIndex: "subservices",
      width: 240,
      render: (text) => (text ? <Tag>{text}</Tag> : "-"),
      fixed: "left",
      sorter: (a, b) => a?.subservices?.localeCompare(b?.subservices),
    }
  ];

  const dummyArray = [
    {
      key: "1",
      material_name: "Boxwood Shrub (3 Gal)",
      subservices: "Shrub Installation (3 Gal)",
      unit: "ea",
      estimated: 200,
      allocated: 116,
      on_order: 41,
      used_to_date: 10,
      purchase_orders: "PO #1267678",
    },
    {
      key: "2",
      material_name: "Daylily (1 Gal)",
      subservices: "Perennial Installation (1 Gal)",
      unit: "ea",
      estimated: 300,
      allocated: 20,
      on_order: 0,
      used_to_date: 10,
      purchase_orders: "PO #867456",
    },
    {
      key: "3",
      material_name: "Screened Topsoil",
      subservices: "Topsoil Import and Spreading",
      unit: "cy",
      estimated: 150.2,
      allocated: 150.2,
      on_order: 0,
      used_to_date: 58.8,
      purchase_orders: "PO #1267678",
    },
    {
      key: "4",
      material_name: "Shredded Hardwood Mulch",
      subservices: "Seed Installation with Straw Mulch",
      unit: "cy",
      estimated: 100.5,
      allocated: 0,
      on_order: 100.5,
      used_to_date: 0,
      purchase_orders: "PO #1267678",
    },
    {
      key: "5",
      material_name: "Blue grass sod palletized",
      subservices: "Sod Installation (Blue grass sod)",
      unit: "pal",
      estimated: 21,
      allocated: 21,
      on_order: 0,
      used_to_date: 16,
      purchase_orders: "PO #1267678",
    },
    {
      key: "6",
      material_name: "Turf Grass Seed Blend",
      subservices: "Seed Installation with Straw Mulch",
      unit: "lb",
      estimated: 45,
      allocated: 0,
      on_order: 45,
      used_to_date: 0,
      purchase_orders: "PO #1267678",
    }
  ];

  return (
    <div className="workOrderMaterial">
      <h3 style={{ position: "absolute", top: "10px" }}> Materials </h3>
      <TableUi
        columns={columns}
        data={{
          count: dummyArray?.length,
          data: dummyArray || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
}
